import { useEffect, useState } from 'react';

// ============================================================================
// LandscapeShield - guarantees a true landscape presentation on phones.
//
// Many mobile browsers (especially iOS Safari) ignore screen.orientation.lock,
// so even after fullscreen the app would stay portrait. Instead of relying on
// the native API we physically rotate the whole UI: while the viewport is
// portrait the app is laid out at 100vh x 100vw and rotated 90deg so it fills
// the screen edge-to-edge in landscape. Pointer events follow the CSS
// transform, so the joystick, buttons and camera drag keep working naturally.
// ============================================================================

const PORTRAIT_WIDTH_LIMIT = 860;

export function LandscapeShield({ children }: { children: React.ReactNode }) {
  const [portrait, setPortrait] = useState(false);

  useEffect(() => {
    const check = () => {
      // Only phones / narrow windows need forced landscape.
      setPortrait(window.innerWidth < PORTRAIT_WIDTH_LIMIT && window.innerHeight > window.innerWidth);
    };
    check();
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, []);

  return <div className={portrait ? 'landscape-shield portrait' : 'landscape-shield'}>{children}</div>;
}
